import { styled } from 'styled-components';

const propsToBeForwarded = [
  'children',
  'onClick',
  'onSubmit',
  'onChange',
  'value',
  'type',
  'name',
  'id',
  'placeholder',
  'href',
  'target',
  'src',
  'width',
  'height',
  'alt',
  'style',
  'lang',
  'title',
  'dangerouslySetInnerHTML',
  'pattern',
  'onKeyDown',
];

const createStyledComponent = (tag: string) =>
  styled(tag).withConfig({
    shouldForwardProp: (props) => {
      const forwardedProp = propsToBeForwarded.find((prop) => props.includes(prop));
      return props === forwardedProp;
    },
  });

export default createStyledComponent;
